<!-- PDF Schedule 3v3 -->

<template>
  <!-- <div class="schedulePDF" > -->
    <!-- <div id="iframeContainer"></div> -->
  <b-button @click="showPrintOption()" pill>
      <printer-icon title='' />
    </b-button>
  <!-- </div> -->
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import EventBus from "@/pages/components/eventBus";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "schedulePDF",
  props: {
    item: Array,
    isntmobile: Boolean,
    locality: String,
    showFerti: Boolean,
  },
  created(){
    this.setLocalization();
  },
  mounted(){
    EventBus.deleteEvent()
    EventBus.onConfirmPrint(() => {
      this.makeReport();
    });
  },
  watch:{
    locality(newV,oldV){
      this.setLocalization();
    }
  },
  data() {
    return {
      name: "",
      local: "",
    };
  },
  methods: {
    parseDate(date) {
      if (date) {
        date = date.split("T");
        let res = date[0].split("-");
        date = res[2] + "/" + res[1] + "/" + res[0];
      } else date = " -						  ";
      return date;
    },
    parseHour(hour) {
      if (hour) {
        hour = hour.split(":");
        hour = hour[0] + ":" + hour[1];
      } else hour = "";
      return hour;
    },
    setColor(actives, day) {
      if (actives) {
        let res = actives.toString(2);
        res = res.split("");
        let n = res.length;
        while (res.length < 7) {
          res.unshift(0);
        }
        res = res.map((i) => parseInt(i));
        res.reverse();
        if (res[day]) return "activeday";
        else return "inactiveday";
      }
    },
    parseToMin(hms) {
      let a = hms.split(":");
      let min = +a[0] * 60 + +a[1];
      return min;
    },
    timeOpening(start, dur, accum) {
      start = this.parseToMin(start);
      let open = start + accum;
      let close = start + accum + dur;
      if (open > 1440) open = open % 1440;
      if (close > 1440) close = close % 1440;
      return {
        open: this.parseMinToHour(open, ":"),
        close: this.parseMinToHour(close, ":"),
      };
    },
    calcFertiDuration(valveOpens, ferti, fertilevel, levelTime) {
      let start = valveOpens ? this.parseToMin(valveOpens) : valveOpens;
      ferti = ferti.filter((e) => e.FERTILEVEL < fertilevel);
      let end = 0;
      if (fertilevel == 1) end = start + levelTime;
      else {
        for (let i = 0; i < ferti.length; i++) {
          let f = ferti[i];
          start += f.duration.TIME;
        }
      }
      return `${this.parseMinToHour(start, ":")} - ${this.parseMinToHour(
        start + levelTime,
        ":"
      )}`;
    },
    durationSchedule(start, end) {
      let sameDay = end > start;
      start = this.parseToMin(start);
      end = this.parseToMin(end);
      let duration;
      if (sameDay) duration = end - start;
      else duration = 24 * 60 - start + end;
      let h;
      let min;
      h = Math.floor(duration / 60);
      min = duration % 60;
      return (
        (h < 10 ? "0" + h : h) + "h" + (min < 10 ? "0" + min : min) + "min"
      );
    },
    parseMinToHour(durationTime, format) {
      if (durationTime) {
        let hours = Math.floor(durationTime / 60);
        let minutes = durationTime % 60;
        if (hours >= 24) hours = hours % 24;
        hours = (hours < 10 ? "0" : "") + hours;
        minutes = (minutes < 10 ? "0" : "") + minutes;
        durationTime = `${hours}${format || "h"}${minutes}`;
      } else durationTime = `00${format || "h"}00`;
      return durationTime;
    },
    parseMinutes(durationTime) {
      return `${durationTime < 10 ? "0" + durationTime : durationTime} min`;
    },
    parseLiters(liters) {
      return liters != 0 ? (liters < 10 ? "0" + liters : liters) + " L" : "-";
    },
    getToday() {
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return dd + "/" + mm + "/" + yyyy;
    },
    showPrintOption() {
      EventBus.showPrintOptions();
    },
    makeReport() {
      let content = [];
      let schedule = this.item;
      let styleLine = ['colorLine','whiteLine'];
      let endTimeSchedule = "";
      let numberOfSchedule = schedule.length;
      for (let i = 0; i < numberOfSchedule; i++) {
        let headerTable = [
          { text: "Etapa", style: "tableHeader" },
          { text: "Horário", style: "tableHeader" },
          { text: "Válvula", style: "tableHeader" },
          { text: "Duração", style: "tableHeader" },
          { text: "Volume", style: "tableHeader" },
          { text: "Bomba", style: "tableHeader" },
          // { },
          // { },
        ];
        let dataTable = [headerTable];
        if (Object.keys(schedule[i]).includes("sublevels")) {
          let numberOfValves = schedule[i].sublevels.length;
          let accumulatedTime = 0;
          let level = 0;
          let ref = 0;
          let durationOnNivel = [];
          for (let v = 0; v < numberOfValves; v++) {
            if (v != 0) {
              ref = schedule[i].sublevels[v - 1].LEVEL;
              if (schedule[i].sublevels[v].LEVEL != ref) {
                accumulatedTime += Math.max(...durationOnNivel);
                durationOnNivel = [];
              }
            }
            durationOnNivel.push(schedule[i].sublevels[v].duration.TIME);
            level = schedule[i].sublevels[v].LEVEL;
            // console.log('numberValves -> ',ref)
            for (let e = 0; e < schedule[i].sublevels[v].ELEMENTS.length; e++) {
              let opening = this.timeOpening(
                schedule[i].START_TIME,
                schedule[i].sublevels[v].duration.TIME,
                accumulatedTime
              );
              dataTable.push([
                {
                  text: schedule[i].sublevels[v].ELEMENTS[e].LEVEL,
                  style: styleLine[dataTable.length % 2],
                },
                {
                  text: opening.open + " - " + opening.close,
                  style: styleLine[dataTable.length % 2],
                },
                {
                  text: schedule[i].sublevels[v].ELEMENTS[e].NAME,
                  style: styleLine[dataTable.length % 2],
                },
                {
                  text: this.parseMinutes(
                    schedule[i].sublevels[v].duration.TIME
                  ),
                  style: styleLine[dataTable.length % 2],
                },
                {
                  text: this.parseLiters(
                    schedule[i].sublevels[v].duration.VOLUME
                  ),
                  style: styleLine[dataTable.length % 2],
                },
                {
                  text: schedule[i].sublevels[v].ELEMENTS[e].PUMP_NAME || "-",
                  style: styleLine[dataTable.length % 2],
                },
              ]);

              if (this.showFerti) {
                let ferti = schedule[i].sublevels[v].FERTI;
                for (let f = 0; f < ferti.length; f++) {
                  dataTable.push([
                    {
                      text:
                        schedule[i].sublevels[v].ELEMENTS[e].LEVEL +
                        "." +
                        ferti[f].FERTILEVEL,
                      style: "fertiLine",
                    },
                    {
                      text: this.calcFertiDuration(
                        opening.open,
                        ferti,
                        ferti[f].FERTILEVEL,
                        ferti[f].duration.TIME
                      ),
                      style: "fertiLine",
                    },
                    { text: ferti[f].ELEMENTS[0].NAME, style: "fertiLine" },

                    {
                      text: this.parseMinutes(ferti[f].duration.TIME),
                      style: "fertiLine",
                    },
                    {
                      text: this.parseLiters(ferti[f].duration.VOLUME),
                      style: "fertiLine",
                    },
                    { text: "FERTI", style: "fertiLine" },
                  ]);
                }
              } else {
                // let ferti = schedule[i].sublevels[v].FERTI;
                if(!!schedule[i].sublevels[v].FERTI.length){
                  dataTable.push([
                    {
                      text:"*",
                      style: "fertiLine",
                    },
                    {
                      text:"*",
                      style: "fertiLine",
                    },
                    { text: `Fertirrigação da ${schedule[i].sublevels[v].ELEMENTS[e].NAME}`, style: "fertiLine" },

                    {
                      text:"*",
                      style: "fertiLine",
                    },
                    {
                      text:"*",
                      style: "fertiLine",
                    },
                    { text:"*", style: "fertiLine" },
                  ]);
                }

              }
            }
            if (v + 1 == numberOfValves) {
              //in the end
              let biggerLastDuration = Math.max(...durationOnNivel); // get the bigger duration of the last level
              endTimeSchedule = this.timeOpening(
                schedule[i].START_TIME,
                biggerLastDuration,
                accumulatedTime
              ).close; //to show on schedule general duration
            }
          }
        }
        let startTimeSchedule = this.parseHour(schedule[i].START_TIME);
        content.push(
          { text: "AGENDA " + schedule[i].NAME, style: "header" },
          {
            text: [
              { text: "Início: ", style: "keytext" },
              this.parseDate(schedule[i].START_DATE) +
                " " +
                startTimeSchedule +
                "		    		      ",
              { text: "Dias de atuação: ", style: "keytext" },
              {
                text: "DOM ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 0),
              },
              {
                text: "SEG ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 1),
              },
              {
                text: "TER ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 2),
              },
              {
                text: "QUA ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 3),
              },
              {
                text: "QUI ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 4),
              },
              {
                text: "SEX ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 5),
              },
              {
                text: "SÁB"+"		    		      ",
                style: this.setColor(schedule[i].ACTIVITY_DAYS, 6),
              },
              { text: "Expira: ", style: "keytext" },
              this.parseDate(schedule[i].END_DATE) +
                " " +
                this.parseHour(schedule[i].END_TIME) +
                "		    		      ",
            ],
            style: "scheduleDuration",
          },
          {
            text: [
              { text: "Horário: ", style: "keytext" },
              startTimeSchedule +
                " - " +
                endTimeSchedule +
                " (" +
                this.durationSchedule(startTimeSchedule, endTimeSchedule) +
                ")" +
                "	  	",

              {text:"Última edição: ",style:"keytext"},
              schedule[i].EDITOR_NAME + " " +"em "+ schedule[i].UPDATE

            ],
            style: "infoGeneral",
          },
          {
            // layout: 'noBorders',
            table: {
              headerRows: 1,
              widths: [
                //etapa, valvula, bomba, horário, duração, volume, t. mínimo, t. avanço
                40,
                70,
                "*",
                70,
                80,
                "*",
                // 'auto', '*', 70, 'auto', 'auto', 'auto', 'auto', 'auto'
              ],
              body: dataTable,
            },
          },
          { text: "", style: "header" },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 10,
                x2: 760,
                y2: 10,
                lineWidth: 0.5,
                color: "#E7EDE4",
                margin: [0, 20, 0, 0],
              },
            ],
          }
        );
      }
      this.print({
        date: this.getToday(),
        local: this.local,
        content: content,
      });
    },
    print(data) {
      let docDefinition = {
        footer: (currentPage, pageCount) => {
          return {
            columns: [
              {
                text: "Desenvolvido pela 3V3 TECNOLOGIA",
                margin: [35, 0],
                alignment: "left",
                color: "#999",
              },
              {
                text: currentPage.toString() + " de " + pageCount,
                margin: [40, 0],
                alignment: "right",
                color: "#999",
              },
            ],
          };
        },
        header: {
          columns: [
            {
              text: data.local,
              alignment: "left",
              margin: [40, 20],
              color: "#999",
            },
            {
              text: data.date,
              alignment: "right",
              margin: [40, 20],
              color: "#999",
            },
          ],
        },
        content: data.content,
        pageMargins: [40, 60, 40, 30],
        pageSize: "A4",
        pageOrientation: 'landscape',
        styles: {
          header: {
            fontSize: 22,
            color: "#3d9161",
            bold: true,
            margin: [0, 10, 0, 10],
          },
          keytext: {
            bold: true,
            color: "#16526B",
          },
          colorLine: {
            fillColor: "#E6E6E6",
            alignment: "center",
          },
          whiteLine: {
            fillColor: "#FFF",
            alignment: "center",
          },
          fertiLine: {
            fillColor: "#B6CDB9",
            italics: true,
            alignment: "center",
          },
          tableHeader: {
            bold: true,
            fillColor: "#3d9161",
            color: "#FFF",
            alignment: "center",
          },
          activeday: {
            bold: true,
            color: "#3d9161",
          },
          inactiveday: {
            color: "red",
            fontSize: 8,
          },
          scheduleDuration: {
            fontSize: 12,
            margin: [0, 0, 0, 5],
          },
          infoGeneral: {
            fontSize: 12,
            margin: [0, 0, 0, 10],
          },
          daysofweek: {
            fontSize: 12,
            margin: [0, 0, 0, 10],
          },
          anotherStyle: {
            italic: true,
            alignment: "right",
          },
        },
      };
      pdfMake.createPdf(docDefinition).open();


    },
    setLocalization() {
      let info = this.locality;
      if (info == "") info = "Localidade";
      else
        this.local = info
          .toUpperCase()
          .split(" ")
          .map((word) => word[0].toUpperCase() + word.substr(1))
          .join(" ");
      // console.log(this.local);
    },
  },
};
</script>


<style scoped>
/* .schedulePDF {
  display: inline;
} */
</style>
